import * as React from 'react';
import Checkbox from '../Checkbox/Checkbox';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { InputLabel, Box } from '@material-ui/core';
import { Translate } from 'react-localize-redux';
import CheckBoxOld from '../CheckboxOld/CheckboxOld';
import { AppDesignScheme } from '../../weborder/Api';

export type RememberMeProps = {
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;

  onChange: (checked: boolean) => any;
  checked: boolean;
};

export type RememberMeClassKey = 'label' | 'description' | 'root';

const RememberMe = withStyles<RememberMeClassKey, {}, RememberMeProps>((theme) => ({
  root: {
    paddingTop: 14
  },
  label: {
    verticalAlign: 'middle',
    color: '#000',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
    paddingLeft: 10
  },
  description: {
    display: 'block',
    paddingLeft: 29,
    color: '#6B6B6B',
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '14px'
  }
}))((props: RememberMeProps & WithStyles<RememberMeClassKey>) => {
  const { classes, onChange, checked } = props;

  return (
    <Box className={classes.root}>
      <InputLabel>
        <CheckBoxOld
          dataFd="rememberMe"
          textId="remember_me"
          onChange={onChange}
          AppDesignScheme={props.AppDesignScheme}
          isDark={props.isDark}
          checked={checked}
        />
        {/*TODO need fix styles, currently use old checkbox*/}
        {/*<Checkbox onChange={(e) => onChange(e.target.checked)} checked={checked} tabIndex={0} />*/}
        {/*<span className={classes.label}>*/}
        {/*  <Translate id="remember_me" />*/}
        {/*</span>*/}
      </InputLabel>
      <Box>
        <span className={classes.description}>
          <Translate id="no_need_to_log_in_for_another_6_months" />
        </span>
        <span className={classes.description}>
          <Translate id="enables_functional_cookies" />
        </span>
      </Box>
    </Box>
  );
});

export default RememberMe;
